// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.loginWrapper {
  min-height: 100vh;
}

.white-label-bg {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: #fff;
  background-repeat: repeat-x;
  background-position: center bottom;
}

.loginWrapperInner {
  width: 265px;
  position: relative;
  z-index: 1;
  border-radius: 4px;
  padding: 60px 0 107px;
  align-items: center;
  box-sizing: border-box;
  margin: auto;
}

.login-logo-wrapper {
  height: 140px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  border-radius: 6px;
  padding: 20px;
  margin-bottom: 75px;
}

.loginForm {
  flex: 1 1;
}
.loginForm .form-control {
  height: 42px;
  font-size: 16px;
  box-shadow: none;
  border-width: 0 0 1px;
  border-radius: 0;
  padding-left: 0;
  padding-right: 0;
}
.loginForm .form-control:focus {
  box-shadow: none;
  border-bottom-width: 2px;
  border-bottom-color: #00c179;
}
.loginForm .control-label {
  color: rgba(0, 0, 0, 0.54);
  font-size: 12px;
}
.loginForm .btn-submit {
  min-width: 220px !important;
  font-size: 14px;
  margin-top: 30px;
}

.login-footer a ~ a:before {
  content: "●";
  display: inline-block;
  margin-right: 12px;
  margin-left: 12px;
}
.login-footer {
  position: absolute;
  left: 100px;
  right: 100px;
  display: flex;
  height: 77px;
  align-items: center;
  justify-content: center;
  bottom: 0;
  text-align: center;
}

@media (max-width: 599px) {
  .loginWrapperInner {
    width: 100%;
    padding: 50px 20px;
  }
  .login-logo-wrapper {
    margin-bottom: 40px;
  }
  .loginForm .btn-submit {
    margin-top: 15px;
  }
  .login-footer {
    left: 30px;
    right: 30px;
    bottom: -50px;
    font-size: 12px;
  }
  .loginWrapper {
    display: flex;
    height: 100vh;
    align-items: center;
    background: #fff;
  }
  .loginForm {
    box-shadow: none !important;
    width: 100%;
    margin: 0 !important;
  }
}
.login-logo {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Login/Style.scss","webpack://./src/assets/variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACC,iBAAA;AACD;;AAGA;EACC,eAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,sBAAA;EACA,2BAAA;EACA,kCAAA;AAAD;;AAEA;EACC,YAZgB;EAahB,kBAAA;EAEA,UAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;EAEA,sBAAA;EACA,YAAA;AADD;;AAGA;EACC,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AAAD;;AAEA;EACC,SAAA;AACD;AAAC;EACC,YAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AAEF;AADE;EACC,gBAAA;EACA,wBAAA;EACA,4BCjDU;ADoDb;AAAC;EACC,0BAAA;EACA,eAAA;AAEF;AACC;EACC,2BAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAIC;EACC,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;AADF;AAJA;EAOC,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;AAAD;;AAGA;EACC;IACC,WAAA;IACA,kBAAA;EAAA;EAED;IACC,mBAAA;EAAA;EAED;IACC,gBAAA;EAAA;EAED;IACC,UAAA;IACA,WAAA;IACA,aAAA;IACA,eAAA;EAAA;EAED;IACC,aAAA;IACA,aAAA;IACA,mBAAA;IACA,gBAAA;EAAA;EAED;IACC,2BAAA;IACA,WAAA;IACA,oBAAA;EAAA;AACF;AAIA;EACC,eAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;AAFD","sourcesContent":["@import \"../../assets/variables\";\n.loginWrapper {\n\tmin-height: 100vh;\n}\n\n$loginFormWidth: 265px;\n.white-label-bg {\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\tbottom: 0;\n\tright: 0;\n\tbackground-color: #fff;\n\tbackground-repeat: repeat-x;\n\tbackground-position: center bottom;\n}\n.loginWrapperInner {\n\twidth: $loginFormWidth;\n\tposition: relative;\n\n\tz-index: 1;\n\tborder-radius: 4px;\n\tpadding: 60px 0 77px + 30px;\n\talign-items: center;\n\t// box-shadow: 0px 1px 5px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.12);\t\n\tbox-sizing: border-box;\n\tmargin: auto;\n}\n.login-logo-wrapper {\n\theight: 140px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tbackground: #fff;\n\tborder-radius: 6px;\n\tpadding: 20px;\n\tmargin-bottom: 75px;\n}\n.loginForm {\n\tflex: 1;\n\t.form-control {\n\t\theight: 42px;\n\t\tfont-size: 16px;\n\t\tbox-shadow: none;\n\t\tborder-width: 0 0 1px;\n\t\tborder-radius: 0;\n\t\tpadding-left: 0;\n\t\tpadding-right: 0;\n\t\t&:focus {\n\t\t\tbox-shadow: none;\n\t\t\tborder-bottom-width: 2px;\n\t\t\tborder-bottom-color: $logoColor;\n\t\t}\n\t}\n\t.control-label {\n\t\tcolor: rgba(0, 0, 0, 0.54);\n\t\tfont-size: 12px;\n\t}\n\n\t.btn-submit {\n\t\tmin-width: 220px !important;\n\t\tfont-size: 14px;\n\t\tmargin-top: 30px;\n\t}\n\t\n}\n.login-footer {\n\ta ~ a:before {\n\t\tcontent: '\\25CF';\n\t\tdisplay: inline-block;\n\t\tmargin-right: 12px;\n\t\tmargin-left: 12px;\n\t}\n\tposition: absolute;\n\tleft: 100px;\n\tright: 100px;\n\tdisplay: flex;\n\theight: 77px;\n\talign-items: center;\n\tjustify-content: center;\n\tbottom: 0;\n\ttext-align: center;\n}\n\n@media (max-width: 599px) {\n\t.loginWrapperInner {\n\t\twidth: 100%;\n\t\tpadding: 50px 20px;\n\t}\n\t.login-logo-wrapper {\n\t\tmargin-bottom: 40px;\n\t}\n\t.loginForm .btn-submit {\n\t\tmargin-top: 15px;\n\t}\n\t.login-footer {\n\t\tleft: 30px;\n\t\tright: 30px;\n\t\tbottom: -50px;\n\t\tfont-size: 12px;\n\t}\n\t.loginWrapper {\n\t\tdisplay: flex;\n\t\theight: 100vh;\n\t\talign-items: center;\n\t\tbackground: #fff;\n\t}\n\t.loginForm {\n\t\tbox-shadow: none !important;\n\t\twidth: 100%;\n\t\tmargin: 0 !important;\n\n\t}\n}\n\n.login-logo {\n\tmax-width: 100%;\n\tmax-height: 100%;\n\twidth: auto;\n\theight: auto;\n}","@import \"functions\";\n@import \"mixins\";\n$themeColor: #00c179;\n$input-focus-box-shadow: none;\n$input-btn-focus-box-shadow: none;\n$btn-active-box-shadow: none;\n$input-focus-border-color: inherit;\n$btn-active-box-shadow: none;\n$input-bg: #fbfeff;\n$input-border-radius: 100px;\n$input-border-radius-sm: 100px;\n$input-border-radius-lg: 100px;\n$input-border-color: #e2e9ef;\n//$input-padding-x-sm: 10px;\n@import \"bs_variables\";\n\n// Layouts\n$filterColWidth: 72px;\n$sidebarWidth : 306px;\n$sidebarMaintenanceWidth: $sidebarWidth + 131px;\n$sidebarWidthResponsive : $sidebarWidth;\n$logoSectionHeight: 44px;\n$headerNavWidth: 150px;\n$headerHeight: 48px;\n$footerHeight: 24px;\n$mapFiltersHeight: 36px;\n$mapWidgetsHeight: 150px;\n$topGap: $headerHeight + 1;\n\n$themeColorInverse: #fff;\n$textColor: #333;\n$body-color: #333;\n$logoColor: $themeColor; //#012D55;\n\n\n\n// Header \n\n$borderColor: transparent;\n$linkColor: #fff;\n$hoverBg: #fff;\n$hoverColor: $themeColor;\n$hoverBorderColor: transparent;\n$subMenuHoverBg: $hoverBg;\n$subMenuHoverColor: $hoverColor;\n$menuBg: #045266;\n$blue : #012D55;\n\n\n// general\n$darkGrey: #666;\n$badgeColor: #fff;\n$badgeBgColor: $darkGrey;\n$greenColor: #28a745;\n$redColor: #dc3545;\n$skyColor: $themeColor;\n$yellowColor: #ffc107;\n$bodyBg: #ffffff;\n$lightGrey: #b7b7b7;\n\n$dropdown-bg: #fff;\n$dropdown-border: darken($dropdown-bg, 30%);\n\n\n\n$danger : $redColor;\n$warning : $yellowColor;\n$success : $greenColor;\n\n\n// Sidebar \n$sidebarBackground: #fff;\n$sidebarzIndex: 99999;\n$sidebarHeadBg: #ffffff;\n$sidebarRowBg: #fff;\n$sidebarRowHoverBg: #f7f7f7;\n$sidebarRowColor: $darkGrey;\n\n\n// typography\n$baseFontSize: 12px;\n$baseIconFontSize: 17px;\n\n\n// Footer\n\n$footerBackground: #ececec;\n$footerFontSize: $baseFontSize + 2;\n\n\n\n\n\n$baseFontFamily: Inter, sans-serif;\n$altFontFamily: 'Bebas Neue', sans-serif;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
